import { isDmStagingResponse, } from './dm-staging.js';
export const dmExceptionKinds = [
    'non_monetary',
    'missing_member',
    'duplicate',
    'titleholder_mismatch',
];
export function isDmExceptionsResponse(value) {
    if (!isDmStagingResponse(value))
        return false;
    const response = value;
    return (response.financialWritesPerformed === false &&
        Number.isInteger(response.evaluatedRows) &&
        Number.isInteger(response.exceptionRows) &&
        dmExceptionKinds.every((kind) => Number.isInteger(response.counts?.[kind]) && response.counts[kind] >= 0) &&
        value.items.every((item) => {
            const row = item;
            return (typeof row.id === 'string' &&
                typeof row.batchId === 'string' &&
                (row.rawValue === null || typeof row.rawValue === 'string') &&
                typeof row.explanation === 'string' &&
                Array.isArray(row.reasons) &&
                row.reasons.length > 0 &&
                row.reasons.every((kind) => dmExceptionKinds.some((k) => k === kind)) &&
                Array.isArray(row.relatedOrigins) &&
                row.relatedOrigins.every((origin) => typeof origin === 'string'));
        }));
}
